/**
 * A price that is not a price.
 *
 * The catalogue carries figures up to 9.999.999.999 and offers carry a round
 * 999.999 where no offer was made: both are markers somebody typed to get past
 * a required field, and printed as money they read as a real amount. They are
 * shown as "auf Anfrage" instead (LST-S12, measured 06.10.2026).
 */

/** From here up, a catalogue price is a marker rather than an amount. */
export const PALO_PLACEHOLDER_PRICE = 999_999_999;

/** What an offer carries when there is no offer. */
export const PALO_PLACEHOLDER_OFFER_PRICE = 999_999;

export const paloIsPlaceholderPrice = (value?: number | null, inOffer = false): boolean => {
    if (null === value || undefined === value) {
        return false;
    }

    // In an offer the marker is that one figure, not everything above it: a
    // real offer may well run past a million.
    return inOffer ? value === PALO_PLACEHOLDER_OFFER_PRICE : value >= PALO_PLACEHOLDER_PRICE;
};
